import { isEqual } from "underscore";
import ColorLib from "tinycolor2";

import globalStyles from "../../style/global_styles";

export interface CustomBimColors {
  InPlace: ColorLib.Instance;
  AsBuilt: ColorLib.Instance;
  DeviationAsDesigned: ColorLib.Instance;
  ClashingAsDesigned: ColorLib.Instance;
  Included: ColorLib.Instance;
  NotBuilt: ColorLib.Instance;
  PartiallyBuilt: ColorLib.Instance;
  Obstructed: ColorLib.Instance;
}

export function defaultBimColors(): CustomBimColors {
  return {
    InPlace: new ColorLib(globalStyles["BIM/Built"]),
    AsBuilt: new ColorLib(globalStyles["BIM/As Built"]),
    DeviationAsDesigned: new ColorLib(globalStyles["BIM/Deviation"]),
    ClashingAsDesigned: new ColorLib(globalStyles["BIM/Clash"]),
    Included: new ColorLib(globalStyles["BIM/Included"]),
    NotBuilt: new ColorLib(globalStyles["BIM/Not Built"]),
    PartiallyBuilt: new ColorLib(globalStyles["BIM/Partially Built"]),
    Obstructed: new ColorLib(globalStyles["BIM/Obstructed"])
  };
}

export function setForgeBimColors(colors: CustomBimColors) {
  const defaultColors = defaultBimColors();
  const changeColors = window.Avvir.changeBimColor;
  changeColors.InPlace((colors.InPlace || defaultColors.InPlace).toHexString());
  changeColors.AsBuilt((colors.AsBuilt || defaultColors.AsBuilt).toHexString());
  changeColors.DeviationAsDesigned((colors.DeviationAsDesigned || defaultColors.DeviationAsDesigned).toHexString());
  changeColors.ClashingAsDesigned((colors.ClashingAsDesigned || defaultColors.ClashingAsDesigned).toHexString());
  changeColors.Included((colors.Included || defaultColors.Included).toHexString());
  changeColors.NotBuilt((colors.NotBuilt || defaultColors.NotBuilt).toHexString());
  changeColors.PartiallyBuilt((colors.PartiallyBuilt || defaultColors.PartiallyBuilt).toHexString());
  changeColors.Obstructed((colors.Obstructed || defaultColors.Obstructed).toHexString());
}

export function areBimColorsDefault(colors: CustomBimColors) {
  return isEqual(defaultBimColors(), colors);
}
